const NextIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.7627 2.5124C7.9877 2.5124 8.2127 2.5874 8.3627 2.7749L16.8377 11.3999C17.1752 11.7374 17.1752 12.2624 16.8377 12.5999L8.3627 21.2249C8.0252 21.5624 7.5002 21.5624 7.16269 21.2249C6.8252 20.8874 6.8252 20.3624 7.1627 20.0249L15.0377 11.9999L7.1252 3.9749C6.7877 3.6374 6.7877 3.1124 7.1252 2.7749C7.3502 2.6249 7.5377 2.5124 7.7627 2.5124Z'
        fill='#9CA3AF'
      />
    </svg>
  );
};

export default NextIcon;
